import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper /* { default global options } */)

Vue.config.productionTip = false

Vue.config.ignoredElements = [
  'a-scene',
  'a-assets',
  'a-sky',
  'a-camera',
  'a-cursor',
  'a-animation',
  'a-entity',
  'a-image'
]

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

function setFontSize() {
  let thisClientWidth = document.documentElement.clientWidth
  store.dispatch('IsPcStore/fetch')
  let isPC = store.getters['IsPcStore/isPc']
  if (isPC) {
    document.documentElement.style.fontSize = '16px'
  } else {
    document.documentElement.style.fontSize = `${(28 * thisClientWidth) /
      768}px`
  }
}
setFontSize()
